import { PersonalInformation } from "Components/Onboarding/shared/PersonalInformation/PersonalInformation";
import { toast } from "sonner";

import { usePartyMutation } from "Api/Mutations/Party/usePartyMutation";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useCurrentUserActingPersonParty } from "Hooks/useCurrentUserActingPersonParty";
import { useCurrentUserParty } from "Hooks/useCurrentUserParty";
import { AddressType, type PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  onNextStepRequested: () => void;
};

export const PersonalInformationStep = ({ onNextStepRequested }: Props) => {
  const { t } = useResource();
  const { actingPartyData, isLoading } = useCurrentUserActingPersonParty();
  const { data: companyParty } = useCurrentUserParty();
  const { mutate: updateParty } = usePartyMutation({
    onError: () =>
      toast.error(t(Resources.Onboarding.Steps.PersonalInformation.SaveError)),
  });

  const companyHeadquartersAddress = companyParty?.addresses?.find(
    (a) => a.type === AddressType.Headquarters,
  );

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  if (!actingPartyData) {
    return <ErrorText>{t(Resources.Error.FormPreparationFailed)}</ErrorText>;
  }

  const onSave = (values: PartyDto) => {
    if (values.publicID) {
      updateParty({
        data: values,
        publicID: values.publicID,
      });
    }
  };

  return (
    <PersonalInformation
      onSave={onSave}
      initialValues={actingPartyData}
      onNextStepRequested={onNextStepRequested}
      companyHeadquartersAddress={companyHeadquartersAddress}
    />
  );
};
